module.exports = __webpack_public_path__ + "static/media/pdf.6ac0f624.svg";